import React from 'react'
import Container from 'muicss/lib/react/container'
import { connect } from 'react-redux'
import FormPage from './FormPage'
import PhotoPage from './PhotoPage'
import FilePage from './FilePage'
import CheckinPage from './CheckinPage'
import IframePage from './IframePage'
import VideoPage from './VideoPage'
import ImagePage from './ImagePage'
import RecognitionPage from './RecognitionPage'
import MessagePage from './MessagePage'

const components = {
  form: FormPage,
  photo: PhotoPage,
  file: FilePage,
  checkin: CheckinPage,
  iframe: IframePage,
  video: VideoPage,
  image: ImagePage,
  recognition: RecognitionPage,
  message: MessagePage,
}


class MissionPage extends React.Component {


  render() {
    const { mission_page, real_answer } = this.props
    const SpecificPage = components[mission_page.page_type]
    return (
      <Container>
        <h4>
          <div
            style={{ whiteSpace: 'pre-wrap' }}
            dangerouslySetInnerHTML={{ __html: mission_page.information }}
          />
        </h4>
        <SpecificPage
          mission_page={mission_page}
          real_answer={real_answer}
        />
      </Container>
    )
  }
}

MissionPage.propTypes = {
  mission_page: React.PropTypes.shape({
    id: React.PropTypes.number,
  }),
  real_answer: React.PropTypes.shape({}),
}


const mapStateToProps = state => ({
  ...state,
})

const mapDispatchToProps = () => ({
})


export default connect(mapStateToProps, mapDispatchToProps)(MissionPage)



// WEBPACK FOOTER //
// ./src/components/MissionShow/MissionPage/index.jsx